import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

function GridContainer({ children, ...rest }) {
  return (
    <Grid container {...rest}>
      {children}
    </Grid>
  );
}

GridContainer.propTypes = {
  children : PropTypes.node.isRequired,
  className: PropTypes.string,
};

GridContainer.defaultProps = {
  className: '',
};

export default GridContainer;
